import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How do you create an on-demand app?",
    answer: `<p>An on demand app requires extensive market research and technical expertise. Once the idea of the app is finalized, it is first designed and then moved into development. This process is managed by experts at Tekrevol, who ensure you get the perfect app.</p>`,
  },
  {
    question: "How much does it cost to develop an on-demand app?",
    answer: `<p>The cost of developing an on-demand app can vary depending upon the custom requirements and features. However, the prices start at around $50,000 and go well above $500,000.</p>`,
  },
  {
    question: "What is an on-demand app?",
    answer: `<p>An on-demand app is one that enables customers and businesses or service providers to connect with each other. The customers can place their orders, and the businesses fulfill the requirements in the given time.</p>`,
  },
  {
    question: "How does the On-demand app work?",
    answer: `<p>The on-demand app is used to bridge the gap between customers and service providers or sellers. Customers can place their orders, and the businesses will be delivering them using their own or the app’s delivery services. On demand, apps are among the most popular apps these days.</p>`,
  },
  {
    question:
      "I would like to protect my on-demand app idea. How do you propose to do that?",
    answer: `<p>To protect your on demand app idea, you need to get it protected through intellectual property laws by filing a patent. Tekrevol helps its clients save millions by assisting them in protecting their intellectual property and taking appropriate action against fakes.</p>`,
  },
  {
    question:
      "How experienced and technically skilled are the designers or developers for on-demand app development?",
    answer: `<p>Tekrevol has been in the app development business for a long time – almost a decade – and we have built numerous amazing applications covering various industries. We have also built on-demand mobile applications for our clients and executed them to perfection. Connect with us to know more.</p>`,
  },
  {
    question:
      " Will Tekrevol submit my on-demand application to the App Store and Play Store?",
    answer: `<p>Absolutely, yes. We will be submitting your app to the respective app store – such as Apple App Store or Google Play Store. We have published quite a few apps, and we are fully aware of the requirements. We make sure that your app is published in time so that you never miss a thing.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>On Demand App Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
